import { render, staticRenderFns } from "./member-profile-section.vue?vue&type=template&id=ac5323c4&scoped=true"
import script from "./member-profile-section.vue?vue&type=script&lang=js"
export * from "./member-profile-section.vue?vue&type=script&lang=js"
import style0 from "./member-profile-section.vue?vue&type=style&index=0&id=ac5323c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5323c4",
  null
  
)

export default component.exports